import { useState } from "react";
import {
	IonButton,
	IonContent,
	IonItem,
	IonList,
	IonPopover,
	IonToast,
} from "@ionic/react";
import { capitalize } from "lodash";
import { useTranslation } from "react-i18next";
import { languages } from "../../i18n";
import { useSettingsContext } from '../../context';
import { DEFAULT_TOAST_DURATION } from '../../constants';

const API_HOST = process.env.REACT_APP_API_HOST;

export function LanguageSwitcher() {
	const { i18n, t } = useTranslation();
	const [open, isOpen] = useState(false);
	const { saveLanguage } = useSettingsContext();

	function onChangeLanguage(language: string) {
		isOpen(true);
		saveLanguage(language);
	}

	const languageMap: { [key: string]: string } = {
		En: "English",
		At: "Austrian German",
		Sw: "Swiss German",
		Fr: "French",
		Ro: "Romanian",
		De: "German",
		It: "Italian",
		Gk: "Greek",
		Sr: "Serbian",
		Bg: "Bulgarian",
		Mk: "North Macedonia",
		Hu: "Hungarian",
		Hr: "Croatia",
	};

	return (
		<>
			<IonButton expand="block" id="change-language-button">
				{t("userSettings.languageSwitcherTitle")} {languageMap[capitalize(i18n.language)]}
			</IonButton>
			<IonPopover trigger="change-language-button" reference="trigger">
				<IonContent class="ion-padding">
					<IonList>
						{languages.map((language) => (
							<IonItem
								detail={false}
								key={language}
								onClick={() => {onChangeLanguage(language)}}
							>
								{languageMap[capitalize(language)]}
							</IonItem>
						))}
					</IonList>
					<IonToast
						duration={DEFAULT_TOAST_DURATION}
						isOpen={open}
						message={t("userSettings.languageSwitcherToast", { language: languageMap[capitalize(i18n.language)] })}
						onDidDismiss={() => isOpen(false)}
					></IonToast>
				</IonContent>
			</IonPopover>
		</>
	);
}
